/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Administrator } from '../../models/administrator';
import { ApiResponseAdministrator } from '../../models/api-response-administrator';

export interface CreateAdministrator$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Administrator
}

export function createAdministrator(http: HttpClient, rootUrl: string, params: CreateAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAdministrator>> {
  const rb = new RequestBuilder(rootUrl, createAdministrator.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseAdministrator>;
    })
  );
}

createAdministrator.PATH = '/v1/api/admin-ui/administrator';
